import {PasswordResponseModel} from './password-response.model';

export class ClientModel {
  clientAuthenticationMethod: string;
  authenticationMethodCode: number;
  funnelMessage: string;
  passwordResponseBody: PasswordResponseModel;

  setPasswordResponseBody(passwordResponseBody: PasswordResponseModel): void {
    this.passwordResponseBody = passwordResponseBody;
  }
}

export class DebitCardPasswordClientModel extends ClientModel {

  constructor() {
    super();
    this.authenticationMethodCode = 4;
    this.clientAuthenticationMethod = 'tarjeta-debito';
    this.funnelMessage = 'intento-td';
  }
}

export class SecurePasswordClientModel extends ClientModel {

  constructor() {
    super();
    this.authenticationMethodCode = 3;
    this.clientAuthenticationMethod = 'clave-segura';
    this.funnelMessage = 'intento-clave-segura';
  }
}

export enum AuthenticationErrors {
  PASSWORD_BLOCKED = 'SK-003',
  PASSWORD_WRONG = 'SK-002',
  PASSWORD_IS_BLOCKED = 'PASSWORD_IS_BLOCKED',
  PASSWORD_IS_WRONG = 'PASSWORD_IS_WRONG'
}



// WEBPACK FOOTER //
// ./src/app/models/client.model.ts